import { useReducer } from 'react';
import {
  ADD_STUDENT,
  ADD_STUDENT_COUNT,
  INIT_REGISTRATION,
  ADD_CURRENT_COUNT,
  CLEAR,
  ADD_CODE,
  PAY_DETAILS,
} from '../types';
import formReducer from './formReducer';
import FormContext from './formContext';
import axios from 'axios';

const FormState = (props) => {
  const initialState = {
    regDetails: null,
    participants: [],
    alert: '',
    payObj: {
      amount: '',
      email: '',
      phone: '',
      msg: '',
      schoolName: '',
      participants: '',
      name: '',
    },
    studentCountValue: 0,
    currentStudentCount: 0,
  };

  const [state, dispatch] = useReducer(formReducer, initialState);

  const addRegDetails = (values) => {
    dispatch({
      type: INIT_REGISTRATION,
      payload: values,
    });
  };

  const addStudent = (values) => {
    dispatch({
      type: ADD_STUDENT,
      payload: values,
    });
  };

  const addStudentCount = (count) => {
    dispatch({
      type: ADD_STUDENT_COUNT,
      payload: count,
    });
  };

  const addCurrentCount = (count) => {
    dispatch({
      type: ADD_CURRENT_COUNT,
      payload: count,
    });
  };

  const addCode = (code) => {
    dispatch({
      type: ADD_CODE,
      payload: code,
    });
  };

  const clearState = () => {
    dispatch({
      type: CLEAR,
    });
  };

  const getPayDetails = async (code) => {
    try {
      const res = await axios.get(
        `https://cnotte-competition.herokuapp.com/api/${code}`
      );

      const data = res.data;

      dispatch({
        type: PAY_DETAILS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const submitForm = async (regDetails, participants) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      //https://cnotte-competition.herokuapp.com/api/form
      const res = await axios.post(
        'https://cnotte-competition.herokuapp.com/api/passport',
        { regDetails, participants },
        config
      );

      const data = res.data;
      console.log(data);

      addCode('done');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <FormContext.Provider
      value={{
        addRegDetails,
        addStudent,
        addStudentCount,
        addCurrentCount,
        clearState,
        addCode,
        getPayDetails,
        submitForm,
        payObj: state.payObj,
        alert: state.alert,
        currentStudentCount: state.currentStudentCount,
        studentCountValue: state.studentCountValue,
        regDetails: state.regDetails,
        participants: state.participants,
      }}
    >
      {props.children}
    </FormContext.Provider>
  );
};

export default FormState;
